import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { HomePage } from '../../pages/home';
import { FeaturesPage } from '../../pages/features';
import { PricingFirmsPage } from '../../pages/pricing/firms';

export function MainLayout() {
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <main className="flex-1 overflow-hidden">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing/firms" element={<PricingFirmsPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
